import { COOKIE_POLICY_URL, PRIVACY_POLICY_URL } from "../../../config";

export default {
    yesNo: {
        yes: 'Yes',
        no: 'No'
    },
    error: {
        genericError: 'It looks like something went wrong. Please, try again later.',
        sessionExpired: 'It appears that your login has expired. Please, try logging back in.',
        restartApp: 'Please restart the app',
        networkError: 'Service is currently not available'
    },
    months: {
        0: 'January',
        1: 'February',
        2: 'March',
        3: 'April',
        4: 'May',
        5: 'June',
        6: 'July',
        7: 'August',
        8: 'September',
        9: 'October',
        10: 'November',
        11: 'December',
    },
    validation: {
        required: 'This field is required',
        email: 'Email address is not valid',
        number: 'Invalid number input',
        max: 'Input is too long (maximum is %{number} characters)',
        passwordsEqual: 'New password must not be the same as old password',
        passwordsDiffer: 'Password mismatch',
        maximumAmount:'The maximum allowed amount per eWallet top-up is 25 EUR',
        minimumAmount:'The minimum allowed amount per eWallet top-up is 1 EUR',
        amountRequired: 'Valid amount is required'
    },
    banners: {
        euFundsTitle: 'The project was co-financed by the European Union from the Cohesion Fund',
        mobileApplicationTitle: 'The mobile app gives you many benefits',
        mobileApplicationText: 'Always have tickets and coupons with you. Shop quickly and safely and be informed of all changes on your route.',
        prometSplitTitle: 'Promet d.o.o. Split wishes you a safe and pleasant ride'
    },
    title: 'Bus tickets',
    price: 'Price',
    currencySymbol: 'KN',
    bottomTabHome: 'Home',
    bottomTabTickets: 'Tickets',
    bottomTabBusLines: 'Bus Lines',
    bottomTabMore: 'Profile',
    save: 'Save',
    cancel: 'Cancel',
    close: 'Close',
    noResults: 'No results',
    downloadInvoice: 'Download invoice',
    downloadDocumentError: 'An error occurred while downloading the document',
    noTransactionsCurrently: 'You currently have no transactions',
    noNotificationsCurrently: 'You currently have no messages received',
    noActiveCoupons: 'You currently have no valid coupons',
    periodNameMontly: 'Monthly coupon',
    periodNameYearly: 'Yearly coupon',
    validFrom: 'Valid from',
    to: 'to',
    findOutMore: 'Find out more',
    areTermsAcceptedErrorMessage: 'Please accept the terms',
    areTermsOfUseAcceptedErrorMessage: 'Please accept the terms of use',
    croatia: 'Croatia',
    inactiveCard: 'The card is inactive',
    cardNotFound: 'Card not found',
    table: {
        itemsPerPage: 'Items per page',
        of: 'of'
    },
    navigation: {
        dashboard: 'Dashboard',
        login: 'Login',
        logout: 'Logout',
        register: 'Register',
        forgotPassword: 'Forgot password',
        resetPassword: 'Reset password',
        changePassword: 'Change password',
        myProfile: 'My profile'
    },
    leftNavigation: {
        eWallet: "eWallet",
        myCoupons: "My coupons",
        myTransactions: "My transactions",
        busLines: "Bus lines",
        routeCalculation: "Route calculation",
        frequentlyAskedQuestions: "FAQ",
        sellingSpots: "Selling spots"
    },
    footer: {
        footerText: 'All rights reserved 2022. Promet d.o.o. Split',
        termsOfUse: 'Terms of use',
        contact: 'Contact'
    },
    contact: {
        title: 'Contact',
        infoText: 'Limited Liability Company for performing the communal activity of passenger transport in public transport',
        address: 'Address',
        oib: 'OIB',
        mb: 'MB',
        freeInfoTelephone: 'Info telephone',
        webAddress: 'Web address',
        emailAddress: 'Email address'
    },
    termsOfUse: {
        title: 'Terms of use'
    },
    routeCalculation: {
        title: 'Route calculation'
    },
    frequentlyAskedQuestions: {
        title: 'Frequently asked questions'
    },
    sellingSpots: {
        title: 'Selling spots',
        showOnMapButton: 'Show on map'
    },
    busLines: {
        title: 'Bus lines'
    },
    verifyActivationMail: {
        title: 'Verify account',
        success: 'Super! Thank you for registering, everything is ready for easy and fast use of the web portal. Thank you and happy journey.'
    },
    dashboard: {
        title: 'Welcome',
        accountStateTitle: 'Your account balance',
        topUpText: 'You want to top up',
        topUpInfoText: 'The maximum amount of the eWallets must not exceed {{primaryAmount}} {{primarySign}} ({{secondaryAmount}} {{secondarySign}}).',
        topUpButtonText: 'Top up now',
        activateFullAccountTitle: 'Activate full profile',
        activateFullAccountText1: 'Become a personalized Promet d.o.o. Split user and discover additional possibilities. Only a full profile user can purchase monthly and annual coupons.',
        activateFullAccountText2: 'How to get a full profile',
        activateFullAccountText2Alt: 'If you have a physical personalized card or already have an activation code proceed to activation.',
        activateFullAccountSelectText: 'Select your status',
        activateFullAccountButtonText: 'Continue on activation',
        activeCouponsTitle: 'My coupons',
        latestTransactionsTitle: 'Latest transactions',
        messagesAndNotificationsTitle: 'Notifications',
        buyCoupon: 'Buy coupon'
    },
    activateFullProfile: {
        title: 'Become a personalized user',
        subtitle: 'Activate full profile',
        explanation: 'The user must decide whether he wants to use a physical card or a mobile application. It is not possible to use both mentioned media at the same time.',
        activateButton: 'Activate',
        activationCodePlaceholder: 'Activation code',
        cardNumberPlaceholder: 'Card number',
        oibPlaceholder: 'OIB',
        chooseMedium: 'Choose medium',
        selectOptions: {
            physical: 'Peronalized physical card',
            mobile: 'Mobile application'
        },
        infoPhysical: 'Enter card number and OIB to use full profile',
        infoMobile: 'Enter activation code to use full profile',
        agreement: 'I accept the terms',
        processStartedSuccessMessage: 'Full profile activation started successfully',
        processStarted: 'Full profile activation is started'
    },
    myProfile: {
        title: 'My account',
        tabs: {
            myProfile: {
                title: 'My profile',
                form: {
                    firstName: 'First name:',
                    lastName: 'Last name:',
                    email: 'Email:'
                },
                cardInfo: {
                    cardNumber: 'Personalized card number:',
                    profile: 'Profile name:',
                    status: 'Card status:'
                },
                profiles: {
                    refreshProfiles: "Refresh profiles",
                    info: "Refresh profiles to verify if you have the right to a student profile.",
                    processStarted: "Process has been started. You will be notified upon its completion."
                }
            },
            personalData: {
                title: 'Personal data',
                form: {
                    firstName: 'First name:',
                    lastName: 'Last name:',
                    oib: 'OIB:',
                    dateOfBirth: 'Date of birth:',
                    address: 'Address:',
                    postCode: 'Post code:',
                    houseNumber: 'House number:',
                    administrativeArea: 'City:'
                }
            },
            changePassword: {
                title: 'Change password',
                button: 'Change password',
                form: {
                    oldPassword: 'Old password:',
                    newPassword: 'New password:',
                    confirmPassword: 'Confirm password:'
                }
            }
        },
        changePasswordSuccess: 'Password changed',
        updateUserSuccess: 'Profile updated successfully',
        updateUserSuccessWithMail: 'Profile updated successfully, we have sent you a verification link to \n{{email}}'
    },
    myTransactions: {
        title: 'My transactions'
    },
    myCoupons: {
        title: 'My coupons'
    },
    cardStates: {
        active: 'Active',
        inactive: 'Inactive'
    },
    tickets: {
        details: {
            title: 'Ticket details',
            alsoWorth: 'Also worth for',
            worthForPeriod: 'Worth for period',
            userId: 'User ID',
            subsidy: 'Subsidy',
            discount: 'Discount',
            numberOfTrips: {
                title: 'Number of trips',
                unlimited: 'Unlimited'
            },
            couponType: {
                monthly: 'Monthly coupon',
                yearly: 'Yearly coupon'
            }
        },
        ticketList: {
            until: 'exp. in',
        },
        ticketFullView: {
            userPictureModalClose: 'Close',
            activationModalClose: 'OK',
            notActiveCouponTicket: 'Coupon is not active',
            details: 'Details',
            showBusOnMap: 'Show bus location',
            busTransfers: 'Bus transfers',
            latestRegisteredRide: 'Last registered bus entrance',
            enterTime: 'Enter time',
            stationName: 'Station',
            busLine: 'Bus line',
            bus: 'Bus',
            topBarText: {
                used: 'Used ticket',
                inactive: 'Purchased ticket',
                active: 'Active ticket',
            },
        },
        activeAndPurchasedTicketsButtonText: 'Active and purchased tickets',
        usedTicketsButtonText: 'Used tickets',
        noUsedTicketsMessage: `You don't have any used tickets`,
        noTicketsMessage: `You don't have any active or purchased tickets`,
        usedTickets: 'Used tickets',
        activeTickets: 'Active tickets',
        purchasedTickets: 'Purchased tickets',
        activateTicket: 'Scan QR code for activation',
        ticketIsValid: 'Valid until',
        expiredTicket: 'Ticket expired',
        usedTicket: 'Ticket expired',
        ticketType: 'Ticket type',
        ticketNumber: 'Ticket number',
        areaCoverage: 'Area coverage',
        purchaseDate: 'Purchase date',
        activatedDate: 'Activated date',
        expiredDate: 'Expired date',
        validUntilDate: 'Valid until date',
        validCoupons: 'Valid coupons',
        ticketDuration: 'Ticket duration',
        fromActivation: 'from activation',
        scanMessage: 'Scan your ticket each time you enter the bus.',
        usedTicketMessage: 'This bus ticket has been used and is no longer valid.',
        notEligibleToPurchaseTheCoupon: 'You are not eligible to purchase the coupon.',
        activeTicketMessage: 'This card is active. Scan your code each time you enter the bus.',
        fullViewTicketScreenTopBarTitle: 'Active ticket',
        activation: {
            activated: 'Your ticket is activated',
            expired: 'Ticket expired',
            valid: 'Your ticket is validated',
            detailsTitle: {
                enterTime: 'Enter time',
                busStation: 'Bus station',
                busLine: 'Bus line',
                busNumber: 'Bus number',
            },
        },
        buyTicket: 'Buy ticket',
        buyCoupon: 'Buy coupon',
        searchButton: 'Show',
        anotherCouponButton: 'I want another coupon',
        buyMessage: 'Select the ticket type you want to buy',
        buy: {
            buyTicketOrCoupon: 'Buy coupon',
            haveSubsidy: 'You have subsidies for purchasing coupons!',
            availableSubsidyCoupons: 'You have subsidies for the following coupons',
            showSubsidisedCoupons: 'Show coupons',
            successScreenMain: 'Successfully purchased tickets',
            successScreenSub: `Don't forget to activate the ticket when entering the bus. Otherwise the ticket is not valid.`,
            errorScreen: 'Error, please try again...',
            loadingScreen: 'Buying tickets, please wait...',
            for: 'for',
            buyFor: 'Buy for',
            buySingleTicket: 'Single ticket',
            buyDailyTicket: 'Daily ticket',
            buyCouponTicket: 'Coupon ticket',
            singleTicket: 'Single ticket',
            dailyTicket: 'Daily ticket',
            multiDayTicket: 'Multi-day ticket',
            couponTicket: 'Coupon ticket',
            childTicket: 'Child ticket',
            day: 'day',
            days: 'days',
            selectTicketDuration: 'Select ticket duration',
            selectTicketValidArea: 'Select ticket coverage area',
            mapViewModalTitle: 'Ticket coverage area',
            warning: 'Warning!',
            dateWarningDescription: "The selected coupon expires in %{days} day(s). Are you sure you want to buy it?",
            overlapWarningDescription: "The coupon you want to buy overlaps with an already valid coupon. Do you still want to buy the selected coupon?",
        },
        ribbonTicketPurchase: 'The ticket is valid only for the marked zone',
        addGoal: 'Add destination',
        selectPlaceholder: 'Select area',
        fromPlaceholder: 'Starting area',
        toPlaceholder: 'End area',
        duration: 'Duration: ',
        validFor: 'Valid for: ',
        allLocations: 'all locations',
        iWantChildTicket: 'Child ticket (6-10 years)',
        totalPrice: 'Total price',
        noMoneyError: 'Insufficient balance. Add money to your prepaid account.',
        balance: 'Wallet balance',
        validMinutes: 'min',
        continueButtonText: 'Continue',
        trafficAreaAll: 'All traffic areas',
    },
    login: {
        title: 'Welcome',
        loginToPrometPortal: 'Login to Promet portal',
        button: 'Login',
        forgotPassword: 'Forgot password',
        success: 'Successful login',
        form: {
            email: 'Email address',
            password: 'Password',
        },
        info: {
            eWallet: "Top up e-wallet",
            penalty: "Pay the penalty ticket",
            busLines: "Bus lines",
            routeCalculation: "Route calculation",
            frequentlyAskedQuestions: "FAQ",
            sellingSpots: "Selling spots"
        },
        noAccount: {
            question: 'No user account?',
            action: 'Register'
        }
    },
    logout: {
        success: 'Logout success'
    },
    loginVerification: {
        title: 'Login verification',
        button: 'Send new email',
        success: 'Verification success',
        form: {
            email: 'Email address',
        },
    },
    register: {
        title: 'Welcome',
        register: "Registration",
        button: 'Register',
        successTitle: 'Registration successful',
        successText: 'Your account has been created! A link to activate it has been sent to {{email}}. After confirmation, your account will be activated.',
        form: {
            firstName: 'First name',
            lastName: 'Last name',
            email: 'E-mail',
            password: 'Password',
            passwordConfirm: 'Repeat password',
            termsOfUseAccept: 'I accept the terms of use',
            areTermsOfUseAcceptedErrorMessage: 'Please accept the terms of use'
        }
    },
    forgotPassword: {
        title: 'Forgot password',
        text: 'Password recovery link sent!',
        description: {
            html: 'We sent you a link to \n<b>{{email}}</b>'
        },
        button: 'Send verification',
        form: {
            email: 'E-mail',
        },
    },
    resetPassword: {
        title: 'Set new password',
        button: 'Change password',
        success: 'Password changed',
        form: {
            password: 'New password',
            confirmPassword: 'Confirm password'
        },
    },
    eWallet: {
        title: 'Top up e-wallet',
        cardNumberLabel: 'Enter the card number for which you want to top up:',
        cardNumber: 'Card number',
        emailLabel: 'Enter the email address for delivery of the invoice:',
        email: 'Email',
        amountLabel: 'Select the amount you want to top up:',
        selectedAmount: 'You have selected an amount:',
        termsOfUseLabel: 'I accept the terms of use',
        accountEWalletAmount: 'Your account balance',
        topUpInfoText: 'The maximum amount of the eWallets must not exceed {{primaryAmount}} {{primarySign}} ({{secondaryAmount}} {{secondarySign}}).',
        topUp: 'Top up',
        checkCardEWalletTitle: 'Check the eWallet balance',
        checkCardEWalletLabel: 'Enter the card number to check the current balance',
        checkCardEWallet: 'Check'
    },
    penaltyPay: {
        title: 'Pay the penalty',
        penaltyNumberLabel: 'Enter the penalty number for which you want to pay',
        penaltyNumber: 'Penalty number',
        getPenalty: 'Show penalty',
        penaltyDetailsTitle: 'Penalty details',
        issuedAt: 'Issued at',
        stationIssuedAt: 'Station issued at',
        stopName: 'Station',
        routeName: 'Route',
        amount: 'Amount',
        description: 'Description',
        emailLabel: 'Enter the email address for delivery of the invoice:',
        email: 'Email',
        penaltyGetError: 'Error while getting the penalty, please check the penalty number and try again',
        termsOfUseLabel: 'I accept the terms of use',
        topUp: 'Pay',
        pay: 'Pay',
        info: {
            title: 'Pay the penalty',
            successText: 'The transaction has been completed and will be processed within 15 minutes. We will notify you over email where you will get the invoice as the confirmation of your payment. If a problem occurs the funds will be refunded.',
            cancelText: 'Transaction canceled.',
            errorText: 'It looks like something went wrong. Please, try again later.',
            returnToHome: 'Return to home',
            tryAgain: 'Try again'   
        }
    },
    eWalletTopUpInfo: {
        title: 'Top up e-wallet',
        successText: 'The transaction has been completed and will be processed within 15 minutes. We will notify you by email after which the amount will appear on the eWallet. If a problem occurs the funds will be refunded.',
        cancelText: 'Transaction canceled.',
        errorText: 'It looks like something went wrong. Please, try again later.',
        returnToHome: 'Return to home',
        tryAgain: 'Try again'
    },
    purchaseCouponInfo: {
        title: 'Purchase coupon',
        successText: 'The transaction has been completed and will be processed within 15 minutes. We will notify you by email after which the coupon will appear on the coupon list. If a problem occurs the funds will be refunded.',
        cancelText: 'Transaction canceled.',
        errorText: 'It looks like something went wrong. Please, try again later.',
        returnToHome: 'Return to home',
        tryAgain: 'Try again'
    },
    euro:{
        rate: 'Conversion rate: 1 EUR = 7,53450 HRK'
    },
    cookies:{
        consentModal: {
            title: 'This site uses cookies',
            description: `We use cookies to ensure the proper functioning of the application. We do not collect any information about your use of the application. To learn more about how your data is used, please visit our cookie policy and/or privacy statement.<br/><a class="cc-link" href="${COOKIE_POLICY_URL.en}">Cookie policy</a><br/><a class="cc-link" href="${PRIVACY_POLICY_URL.en}">Privacy statement</a>`,
            acceptAllBtn: 'Accept all',
            rejectAllBtn: 'Reject all',
            showPreferencesBtn: 'Manage preferences',
        },
        preferencesModal: {
            title: 'Cookie preferences',
            acceptAllBtn: 'Accept all',
            acceptNecessaryBtn: 'Reject all except necessary',
            savePreferencesBtn: 'Save preferences',
            closeIconLabel: 'Close',
            sections: [
                {
                    title: 'Cookie usage',
                    description: `We use cookies to ensure the proper functioning of the application. We do not collect any information about your use of the application. To learn more about how your data is used, please visit our cookie policy and/or privacy statement.<br/><a class="cc-link" href="${COOKIE_POLICY_URL.en}">Cookie policy</a><br/><a class="cc-link" href="${PRIVACY_POLICY_URL.en}">Privacy statement</a>`
                },
                {
                    title: 'Strictly necessary cookies',
                    description: 'These cookies are essential for the proper functioning of the website. Without these cookies, the website would not work properly.',
                    linkedCategory: 'necessary'
                },
            ]
        }
    }
};
